// extracted by mini-css-extract-plugin
module.exports = {"guideLink":"EXtC6","articleIcon":"Pce6P","topLevel":"D5Mrb","highlight":"_2cYoG","nameContainer":"_29RmC"};